var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"copy-to-clipboard",on:{"click":function($event){return _vm.copyToClipboard(_vm.text)}}},[_c('fa-icon',{attrs:{"icon":['fal', 'copy']}}),(_vm.displayText)?_c('span',{staticClass:"ml-2"},[_vm._v(_vm._s(_vm.displayText))]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35f06782","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/CopyToClipboard.vue
// module id = null
// module chunks = 